import type { FaireProductEntity } from "../../entity_types/product";

export const p_d7v3xth2: FaireProductEntity = {
  token: "p_d7v3xth2",
  type: "product",
  name: "Fringeless Baby Moccasins - Leather Baby Shoes (Home Run)",
  brandToken: "b_5ytgyrzl",
  brandName: "BirdRock Baby",
  imageUrl:
    "https://cdn.faire.com/fastly/c06a95783ffe08338d282c8c4eb37379c00886413bad690661fd45abbfcaef1d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e8b73c8617793a00c638947c2535bbf509458b58f728ee1ae5ac8a7a9f3578bc.jpeg",
    "https://cdn.faire.com/fastly/3947b1ea2a4367ba26aff30215ce9c69f2c3c7355e65f1a5b576b06570436eca.jpeg",
    "https://cdn.faire.com/fastly/d7ff3d25f6930787d52493548b7040be78cf3c30e43f2a3a9d0fb9ee3598b8da.jpeg",
  ],
  priceDollars: 15,
  description:
    'We think we hit this one out of the park! The Home Run moccasin is tons of fun at the playground and at the ball park.\n\nSizing: \nUS 2 (0-6 Months, 3.75" Sole).\nUS 3 (3-6 Months; 4.125" Sole)\nUS 4 (6-12 Months, 4.5" Sole).\nUS 5.5 (12-18 Months, 5.0" Sole).\nUS 6.5 (18-24 Months, 5.25" Sole).\nUS 8 (2-3 Years, 5.75" Sole).\n',
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:43.448Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
